import { Pagination, Button } from 'react-daisyui'

type PaginationBarProps = {
  onChange: any;
  itemCount: number;
  currentPage: number;
  pageSize: number;
}

/**
 * Paginated buttons generator
 * @param itemCount The total number of paginated items
 * @param currentPage The current page of the paginated data
 * @param pages The total number of pages of paginated data
 * @param onChange Handler for when pagination button is clicked
 * @param pageSize Total items display on current page e.g. 10 20 50 100
 * @returns React DaisyUI Buttons
 */
function PaginationItems(itemCount: number, currentPage: number, pages: number,  onChange: any, pageSize : number){
    let items: Array<any> = [];

    if (pages <= pageSize) {
      for (let number = 1; number <= pages; number++) {
        items.push(
          <Button type="button" disabled={number === currentPage} active={number === currentPage} key={number} onClick={() => onChange(number)}>{number}</Button>
        );
      }
    } else {
      for (let number = 1; number <= pages; number++) {
        if (number === 1 ||  number === currentPage || number === currentPage - 1 || number === currentPage + 1 || number === currentPage - 2 || number === currentPage + 2 || number === pages) {
          items.push(
            <Button type="button" disabled={number === currentPage} key={number} active={number === currentPage} onClick={() => onChange(number)}>{number}</Button>
          );
        } else if (number === currentPage - 3 || number === currentPage + 3 ) {
          items.push(
            <Button type="button" disabled={true} key={number}>...</Button>
          );
        }
      }
    }
    return <>{items.map((item)=>item)}</>;
}

/**
 * Calculates the number of pagination pages per the item count and the pageSize
 * @param itemCount How many items of paginated data
 * @param pageSize The size of each page
 * @returns Number of pages
 */
function PageCount(itemCount: number, pageSize: number ): number{console.log( Math.ceil(itemCount / pageSize))
  return Math.ceil(itemCount / pageSize); 
}

const PaginationBar = (props: PaginationBarProps) => {
  let pages = PageCount(props.itemCount, props.pageSize);
  const items = PaginationItems(props.itemCount,props.currentPage, pages, props.onChange, props.pageSize)

    return  (
      <>
        <nav aria-label="Page navigation example">
          <ul className="pagination">
            <Pagination>
              <Button type="button" disabled={props.currentPage === 1} onClick={() => props.onChange(props.currentPage - 1)}>Previous</Button>
              {items}
              <Button type="button" disabled={props.currentPage === pages} onClick={() => props.onChange(props.currentPage + 1)}>Next</Button>
            </Pagination>
          </ul>
        </nav>
      </>
    );
};

export default PaginationBar;
